// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let ImageUtils = require("./imageUtils");
let ReasonPromise = require("../../ReasonPromise.bs.js");
let Stdlib_Nullable = require("@rescript/runtime/lib/js/Stdlib_Nullable.js");

function resize(maxWidth, maxHeight, file) {
  return ImageUtils.resize(file, Stdlib_Nullable.fromOption(maxWidth), Stdlib_Nullable.fromOption(maxHeight));
}

function _getCroppedImage(prim0, prim1) {
  return ImageUtils.getCroppedImg(prim0, prim1);
}

function getDimensions(dataUrl) {
  let match = ReasonPromise.pending();
  let resolve = match[1];
  let image = new Image();
  image.addEventListener("load", param => resolve({
    width: image.width,
    height: image.height
  }));
  image.addEventListener("error", param => resolve(undefined));
  image.src = dataUrl;
  return match[0];
}

let getCroppedImage = _getCroppedImage;

exports.getCroppedImage = getCroppedImage;
exports.resize = resize;
exports.getDimensions = getDimensions;
/* ./imageUtils Not a pure module */
